(function () {
  'use strict';

  // Registro global: sectionId → datos de hermanos
  window.__siblingStock__ = window.__siblingStock__ || {};

  // ── Parchear toggleAddButton en el prototipo ───────────────────────────
  function patchPrototype() {
    var Ctor = customElements.get('variant-radios');
    if (!Ctor || Ctor.__siblingPatched__) return;
    Ctor.__siblingPatched__ = true;

    var targetProto = null;
    var p = Ctor.prototype;
    while (p) {
      if (Object.prototype.hasOwnProperty.call(p, 'toggleAddButton')) {
        targetProto = p;
        break;
      }
      p = Object.getPrototypeOf(p);
    }
    if (!targetProto) {
      console.warn('[SiblingStock] toggleAddButton no encontrado en prototipo');
      return;
    }

    var origToggle = targetProto.toggleAddButton;
    console.log('[SiblingStock] Parcheando prototipo toggleAddButton');

    targetProto.toggleAddButton = function (disable, text, modifyClass) {
      console.log('[SiblingStock] toggleAddButton llamado | disable:', disable, '| section:', this.dataset && this.dataset.section);

      if (disable) {
        var sid = this.dataset && this.dataset.section;
        var sibData = sid && window.__siblingStock__[sid];
        if (sibData) {
          var checked = this.querySelector('input[type="radio"]:checked');
          var size = checked ? checked.value : null;
          var cur = size ? sibData.currentBySize[size] : null;
          var sib = size ? sibData.siblingBySize[size] : null;
          console.log('[SiblingStock] Talla:', size, '| cur.available:', cur && cur.available, '| sib.available:', sib && sib.available);
          if (cur && !cur.available && sib && sib.available) {
            console.log('[SiblingStock] Hermano cubre talla', size, '→ manteniendo botón habilitado (variant:', sib.id, ')');
            origToggle.call(this, false, null, false);
            var pf = this.closest('product-form') || document.querySelector('product-form');
            if (pf) {
              var input = pf.querySelector('form input[name="id"]');
              if (input) input.value = String(sib.id);
              var btn = pf.querySelector('[name="add"]');
              var span = btn && (btn.querySelector('span') || btn.querySelector('.btn__text'));
              if (span) span.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Agregar al carrito';
            }
            var bis = document.getElementById('BIS_trigger');
            if (bis) bis.style.display = 'none';
            return;
          }
        }
      }
      origToggle.call(this, disable, text, modifyClass);
    };
  }

  // ── Inicialización principal ───────────────────────────────────────────
  function initSiblingStock() {
    var dataEl = document.querySelector('[id^="SiblingData-"]');
    if (!dataEl) { console.log('[SiblingStock] No se encontró SiblingData'); return; }

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[SiblingStock] Error JSON', e); return; }

    var sectionId = data.sectionId;
    var siblings = data.siblings || []; // array de {variants:[...]}

    console.log('[SiblingStock] Init | sectionId:', sectionId, '| hermanos:', siblings.length);

    var variantRadios = document.querySelector('variant-radios[data-section="' + sectionId + '"]');
    if (!variantRadios) { console.warn('[SiblingStock] variant-radios no encontrado'); return; }

    var currentVariantsEl = variantRadios.querySelector('script[type="application/json"]');
    if (!currentVariantsEl) { console.warn('[SiblingStock] JSON de variantes no encontrado'); return; }

    var currentVariants;
    try { currentVariants = JSON.parse(currentVariantsEl.textContent); } catch (e) { return; }

    // Mapa talla → variante actual
    var currentBySize = {};
    currentVariants.forEach(function (v) { currentBySize[v.option1] = v; });

    // Mapa talla → mejor variante hermana disponible (primer hermano que cubra)
    var siblingBySize = {};
    siblings.forEach(function (sibling) {
      (sibling.variants || []).forEach(function (v) {
        if (v.available && !siblingBySize[v.option1]) {
          siblingBySize[v.option1] = v;
        }
      });
    });

    console.log('[SiblingStock] Tallas producto actual:', Object.keys(currentBySize));
    console.log('[SiblingStock] Tallas cubiertas por hermanos:', Object.keys(siblingBySize));

    window.__siblingStock__[sectionId] = {
      currentBySize: currentBySize,
      siblingBySize: siblingBySize
    };

    patchPrototype();

    // ── Quitar estilo disabled de tallas cubiertas por hermanos ───────────
    function fixLabels(vr) {
      vr = vr || variantRadios;
      vr.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var cur = currentBySize[radio.value];
        var sib = siblingBySize[radio.value];
        if (cur && !cur.available && sib && sib.available) {
          radio.disabled = false;
          var label = vr.querySelector('label[for="' + radio.id + '"]');
          if (label) {
            label.classList.remove('disabled', 'form__input-label--disabled', 'soldout', 'sold-out');
            label.removeAttribute('disabled');
          }
        }
      });
    }

    fixLabels();

    // ── Corregir estado inicial si talla agotada está pre-seleccionada ────
    (function () {
      var checked = variantRadios.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var cur = currentBySize[checked.value];
      var sib = siblingBySize[checked.value];
      if (!(cur && !cur.available && sib && sib.available)) return;
      var pf = document.querySelector('product-form');
      if (!pf) return;
      var input = pf.querySelector('form input[name="id"]');
      if (input) input.value = String(sib.id);
      var btn = pf.querySelector('[name="add"]');
      if (btn) {
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span') || btn.querySelector('.btn__text');
        if (span) span.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Agregar al carrito';
      }
      var bis = document.getElementById('BIS_trigger');
      if (bis) bis.style.display = 'none';
    })();

    // ── Re-aplicar fix de labels tras cambio de talla ─────────────────────
    variantRadios.addEventListener('change', function () {
      setTimeout(function () {
        var vr = document.querySelector('variant-radios[data-section="' + sectionId + '"]');
        if (vr) fixLabels(vr);
      }, 50);
    });

    // ── Seguridad en submit ────────────────────────────────────────────────
    var pfEl = document.querySelector('product-form');
    if (pfEl) {
      pfEl.addEventListener('submit', function () {
        var form = pfEl.querySelector('form') || pfEl;
        var input = form.querySelector('input[name="id"]');
        if (!input) return;
        var varId = parseInt(input.value, 10);
        var cur = currentVariants.find(function (v) { return v.id === varId; });
        if (cur && !cur.available) {
          var sib = siblingBySize[cur.option1];
          if (sib && sib.available) {
            console.log('[SiblingStock] Submit: usando variante hermano', sib.id);
            input.value = String(sib.id);
          }
        }
      }, true);
    }
  }

  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    customElements.whenDefined('variant-radios').then(initSiblingStock);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiblingStock);
  } else {
    initSiblingStock();
  }
})();
